import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import Banner from '@components/Banner/Banner.vue';
import DetailPage from '@shell/components/Resource/Detail/Page.vue';
import Masthead from '@shell/components/Resource/Detail/Masthead/index.vue';
import { useDefaultMastheadProps } from '@shell/components/Resource/Detail/Masthead/composable';
import { useResourceDetailBannerProps } from '@shell/components/Resource/Detail/composables';
import Tab from '@shell/components/Tabbed/Tab.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import CertManagerResourceTabs from '../components/CertManagerResourceTabs.vue';
import { CERTIFICATE_REQUEST_HEADERS } from '../table-headers';
import { useRelatedTypes } from '../composables/useRelatedTypes';
import { CERT_MANAGER } from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'cert-manager.io.certificate',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

// Related resources are read from the store; a directly loaded detail page has none yet. Gate the
// related-data parts of the template on `loaded` so they render against the populated store. The
// masthead cards read the model reactively, so they fill in on their own once the store is loaded.
const { loaded } = useRelatedTypes([CERT_MANAGER.CERTIFICATE_REQUEST, CERT_MANAGER.ORDER, CERT_MANAGER.CHALLENGE]);

const { t } = useI18n(useStore());

// The masthead renders the title bar (with the Renew action and Show Configuration), the
// identifying information from the model's `details`, and the card row from the model's `cards` -
// Issuance Status, Resources and Insights.
const mastheadProps = useDefaultMastheadProps(props.value);
const bannerProps = useResourceDetailBannerProps(props.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailPage, null, {
    "top-area": _withCtx(() => [
      _createVNode(Masthead, _normalizeProps(_guardReactiveProps(_unref(mastheadProps))), {
        banner: _withCtx(() => [
          (_unref(bannerProps))
            ? (_openBlock(), _createBlock(Banner, _mergeProps({ key: 0 }, _unref(bannerProps), {
                class: "state-banner",
                role: "status"
              }), null, 16))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16)
    ]),
    "bottom-area": _withCtx(() => [
      _createVNode(CertManagerResourceTabs, { value: __props.value }, {
        default: _withCtx(() => [
          _createVNode(Tab, {
            name: "issuance-history",
            label: _unref(t)('certManager.certificate.tab.issuanceHistory'),
            weight: 10
          }, {
            default: _withCtx(() => [
              _createVNode(ResourceTable, {
                rows: _unref(loaded) ? __props.value.certificateRequests : [],
                headers: _unref(CERTIFICATE_REQUEST_HEADERS),
                "table-actions": false,
                groupable: false
              }, null, 8, ["rows", "headers"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})